export default function ReviewEditController($stateParams, ReviewService, OPTIONS, NotificationService) {
  var vm = this;

  vm.options = {
    statuses: OPTIONS.statuses.reviews.concat(OPTIONS.statuses.reviewsEdit),
    ratings: OPTIONS.reviews_ratings,
  };

  vm.reviewId = $stateParams.reviewId;
  vm.review = $stateParams.review;
  vm.isLoading = false;

  vm.init = init;
  vm.getReview = getReview;
  vm.updateReview = updateReview;

  init();

  function init() {
    if (!vm.review) {
      vm.getReview();
    }
  }

  function getReview() {
    if (vm.isLoading) {
      return;
    }

    vm.isLoading = true;
    ReviewService.retrieveReview(vm.reviewId)
      .then(function(res) {
        vm.review = res.data;
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function updateReview() {
    var reviewToUpdate;

    if (!vm.review || vm.isLoading) {
      return;
    }

    reviewToUpdate = buildReviewToUpdate(vm.review);
    vm.isLoading = true;
    ReviewService.updateReview(vm.review.id, reviewToUpdate)
      .then(function() {
        NotificationService.success('The review was successfully updated.');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function buildReviewToUpdate(review) {
    return { status: review.status, rating: review.rating, description: review.description, locale: review.locale };
  }
}



// WEBPACK FOOTER //
// ./src/app/reviews/review-edit.controller.js